import { WIDTH } from "./encodeNumberArray";
import { NUMBER_MARKER_BY_WIDTH } from "./markers";

const GETTER_BY_WIDTH = {
  1: "getUint8",
  2: "getUint16",
  4: "getUint32",
} as const;

// Reverse lookup: marker byte → width. Avoids Object.entries.find on every call.
const WIDTH_BY_MARKER: Record<number, WIDTH> = {
  [NUMBER_MARKER_BY_WIDTH[1]]: 1,
  [NUMBER_MARKER_BY_WIDTH[2]]: 2,
  [NUMBER_MARKER_BY_WIDTH[4]]: 4,
};

export function decodeNumber(data: Uint8Array, offset = 0): [number, number] {
  const marker = data[offset];
  const width = WIDTH_BY_MARKER[marker] as WIDTH;
  const getter = GETTER_BY_WIDTH[width];
  // Use data.byteOffset so this works correctly when data is a view into a
  // larger buffer (byteOffset != 0), not just a fresh zero-based copy.
  const view = new DataView(data.buffer);
  return [view[getter](data.byteOffset + offset + 1), width + 1];
}
